import { forwardRef, InputHTMLAttributes, useState } from 'react';
import styled from 'styled-components';

export interface VisibaCortexBaseInputProps extends InputHTMLAttributes<HTMLInputElement> {
	type:
		| 'button'
		| 'checkbox'
		| 'color'
		| 'date'
		| 'datetime-local'
		| 'email'
		| 'file'
		| 'hidden'
		| 'image'
		| 'month'
		| 'number'
		| 'password'
		| 'radio'
		| 'range'
		| 'reset'
		| 'search'
		| 'submit'
		| 'tel'
		| 'text'
		| 'time'
		| 'url'
		| 'week';
}

const elements = {
	baseInput: styled.input`
		display: block;
		font: inherit;
		color: currentColor;
		border: 0;
		margin: 0;
		padding: 6px 0 7px;
		display: block;
		min-width: 0;
		box-sizing: content-box;
		background: none;
		-webkit-tap-highlight-color: transparent;
		outline: none;
		font-size: 1rem;
	`,
};

/**
 * # cortex:react-ui-std:comp:BaseInput
 */
export const BaseInput = forwardRef<HTMLInputElement, VisibaCortexBaseInputProps>(function BaseInput(props, ref) {
	const {
		// Takes out these values to be used as variables here.
		className,
		disabled,
		type,
		// defaults.
		tabIndex = 0,
		// Spreads anything else.
		...rest
	} = props;

	const [isFocused, setIsFocus] = useState(false);

	if (disabled && isFocused) setIsFocus(false);

	return (
		<elements.baseInput
			ref={ref}
			aria-invalid={true}
			// biome-ignore lint/a11y/useValidAriaValues: suppressed due to migration - should be fixed
			aria-describedby={''}
			className={className}
			disabled={disabled}
			tabIndex={disabled ? -1 : tabIndex}
			type={type}
			{
				// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
				...(rest as any) /* TODO: REMOVE INJECTION ISSUES */
			}
		/>
	);
});
